import { ArrowUpRight } from "lucide-react";
import { waLink, trackWhatsAppClick } from "../lib/whatsapp";

const variants = {
  primary:
    "bg-gold text-ink hover:bg-gold-light shadow-[0_0_40px_rgba(252,172,4,0.22)] hover:shadow-[0_0_60px_rgba(252,172,4,0.4)]",
  outline:
    "border border-bone/25 text-bone hover:border-gold hover:text-gold bg-black/30 backdrop-blur-sm",
  dark: "bg-bone text-ink hover:bg-white",
};

export const WaCta = ({
  message,
  location,
  label,
  variant = "primary",
  className = "",
  testId,
}) => (
  <a
    href={waLink(message)}
    target="_blank"
    rel="noopener noreferrer"
    data-testid={testId}
    onClick={() => trackWhatsAppClick(location, label)}
    className={`group inline-flex items-center justify-center gap-2.5 rounded-full px-7 py-4 font-display text-sm font-bold uppercase tracking-wider transition-[background-color,border-color,color,box-shadow] duration-300 ${variants[variant]} ${className}`}
  >
    {label}
    <ArrowUpRight
      className="h-4 w-4 transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5"
      aria-hidden="true"
    />
  </a>
);
